import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';



import HomePage from "./components/Homepage.js"



import AutomateLoginPages from "./components/UIAutomationPractice/AutomateLoginPages.js";
import AutomatingEcommerceFlows from "./components/UIAutomationPractice/AutomatingEcommerceFlows.js";
import AutomatingWebForms from "./components/UIAutomationPractice/AutomatingWebForms.js";
import ExploreAutomateUIElements from "./components/UIAutomationPractice/ExploreAutomateUIElements.js";
import FlightBookingAutomation from "./components/UIAutomationPractice/FlightBookingAutomation.js";
import MasteringXPathforUIAutomation from "./components/UIAutomationPractice/MasteringXPathforUIAutomation.js";

import ForgetPasswordPage from "./components/UIAutomationPractice/ForgetPasswordPage.js";
import RegistrationPage from "./components/UIAutomationPractice/RegistrationPage.js";
import ScrollToTop from "./ScrollToTop.js";
import PracticeScenariosPage from "./components/PracticeScenariosPage.js";

import SeleniumXPathGuide from "./components/UIAutomationPractice/SeleniumXPathGuide.js";
import AboutPage from './components/AboutPage.js';


function App() {
  return (
    <Router>
      <ScrollToTop />
    <Routes>
   



      

      <Route path="/" element={<HomePage />} />
      
      <Route path="/practice-login-form" element={<AutomateLoginPages />} />
      <Route path="/practice-forms" element={<AutomatingWebForms />} />
      <Route path="/practice-different-ui-elements" element={<ExploreAutomateUIElements />} />
      <Route path="/flight-booking-scenarios" element={<FlightBookingAutomation />} />
      <Route path="/practice-ecommerece-website" element={<AutomatingEcommerceFlows />} />
      <Route path="/practice-xpath" element={<MasteringXPathforUIAutomation />} />

      <Route path="/practice-page-selection" element={<PracticeScenariosPage />} />

      <Route path="/forget-password" element={<ForgetPasswordPage />} />
      <Route path="/register" element={<RegistrationPage />} />

      <Route path="/SeleniumXPathGuide" element={<SeleniumXPathGuide />} />
      <Route path="/AboutPage" element={<AboutPage />} />
      
      
      

    </Routes>
  </Router>
  );
}

export default App;
